import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';

export default function decorateurRectangleReseauxNumeriquesSemaine(rectangle) {
  rectangle.texte = false;
  rectangle.widthOccupation = false;
  rectangle.stroke = niveauDispo.COULEUR_DISPO_DISPONIBLE;
  rectangle.fill = niveauDispo.COULEUR_BLANCHE;
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleReseauxNumeriquesSemaine.js